export default __webpack_public_path__ + "static/media/send-to-chat.c85405fd.svg";